import ContentLayer from './ContentLayer'

export default ContentLayer
